<template>
  <!-- 首尾 -->
  <div class="all">
    <!-- pc端 -->
    <div class="home">
      <div id="navbar" class="header">
        <div
          class="top"
          :class="{
            active_bg: $route.path == '/home',
          }"
        >
<!--          <div class="pic" v-show="$route.path == '/home'">-->
          <div class="pic">
            <img src="../../assets/images/logo_1.png" alt="" />
          </div>

          <ul class="top_title">
            <li class="title_li">
              <a
                href="javascript:void(0)"
                @click="jumpUrl({ path: '/home' })"
                :class="{ active: $route.path == '/home' }"
                >首页
                <!-- 下划线 -->
                <div class="line" v-show="$route.path == '/home'"></div>
              </a>
            </li>
            <li class="title_li">
              <a
                href="javascript:void(0)"
                @click="jumpUrl('/up')"
                :class="{ active: $route.path == '/up' }"
                >我们的优势
                <!-- 下划线 -->
                <div class="line" v-show="$route.path == '/up'"></div>
              </a>
            </li>
            <li class="title_li">
              <a
                href="javascript:void(0)"
                @click="jumpUrl('/case')"
                :class="{ active: $route.path == '/case' }"
                >典型案例
                <div class="line" v-show="$route.path == '/case'"></div>
              </a>
            </li>
            <li class="title_li">
              <a
                href="javascript:void(0)"
                @click="jumpUrl('/skill')"
                :class="{ active: $route.path == '/skill' }"
                >技术支持
                <div class="line" v-show="$route.path == '/skill'"></div>
              </a>
            </li>
            <li class="title_li">
              <a
                href="javascript:void(0)"
                @click="jumpUrl('/fixed')"
                :class="{ active: $route.path == '/fixed' }"
                >解决方案
                <div class="line" v-show="$route.path == '/fixed'"></div>
              </a>
            </li>
            <li class="title_li">
              <a
                href="javascript:void(0)"
                @click="jumpUrl({ path: '/news', params: { isPc: isPC } })"
                :class="{ active: isNewsPath() }"
                >行业新闻
                <!-- 下划线 -->
                <div class="line" v-show="isNewsPath()"></div>
              </a>
            </li>
            <li class="title_li">
              <a
                  href="javascript:void(0)"
                  @click="jumpUrl({ path: '/about', params: { isPc: isPC } })"
                  :class="{ active: $route.path == '/about' }"
              >关于我们
                <!-- 下划线 -->
                <div class="line" v-show="$route.path == '/about'"></div>
              </a>
            </li>
            <li class="title_li">
              <a
                  href="/web-manage"
                  :class="{ active: $route.path == '/staff' }"
              >员工入口
                <!-- 下划线 -->
                <div class="line" v-show="$route.path == '/staff'"></div>
              </a>
            </li>
<!--语言切换按钮-->
            <li class="title_li">
              <label class="switch" @click="changeLang(`/ja${$route.path}`)">
                <input type="checkbox">
                <span class="slider round">
                  <img class="lan_btn" src="../../assets/images/ch_icon.png" alt="" />
                </span>
                <!--<span class="slider-label">ON</span>
                <span class="slider-label on">OFF</span>-->
              </label>
            </li>
<!--            <li class="about">
              <a
                href="javascript:void(0)"
                @click="jumpUrl({ path: '/about', params: { isPc: isPC } })"
                >关于我们</a
              >
            </li>-->
          </ul>
        </div>
      </div>
      
      <div class="details">
        <router-view></router-view>
      </div>

      <div class="footer">
        <!-- 联系我们 -->
        <div class="contact">
          <div class="contact_left">
            <p class="us">联系我们</p>
            <p class="iphone">
              <span class="phone">服务热线：</span><br />400-811-8580
            </p>
            <p class="address">
              <span class="ad" @mouseover="showAd('3')" @mouseleave="outShow"
                >日本总社</span
              >&nbsp;|&nbsp;
              <span class="ad" @mouseover="showAd('2')" @mouseleave="outShow"
                >上海总公司</span
              >&nbsp;|&nbsp;
              <span class="ad" @mouseover="showAd('1')" @mouseleave="outShow"
                >合肥开发部</span
              >
            </p>
            <!-- 地区 -->
            <!-- 合肥 -->
            <div class="showAdd" v-show="isshowAd == '1'">
              <img src="../../assets/images/adrhefei.png" alt="" />
              <!-- 小三角 -->
              <div class="trangle1"></div>
            </div>
            <!-- 上海 -->
            <div class="showAdd" v-show="isshowAd == '2'">
              <img src="../../assets/images/adrshanghai.png" alt="" />
              <!-- 小三角 -->
              <div class="trangle2"></div>
            </div>
            <!-- 日本 -->
            <div class="showAdd" v-show="isshowAd == '3'">
              <img src="../../assets/images/adrriben.png" alt="" />
              <!-- 小三角 -->
              <div class="trangle3"></div>
            </div>

            <p class="jpic">
              <img src="../../assets/images/white1.png" alt="" /><span
                class="jp"
                >〒160-0022<br />東京都新宿区新宿2-5-10　アーバンセンター新宿7F</span
              >
            </p>
          </div>
          <div class="contact_right">
            <p class="contact_right_title">免费网络咨询服务</p>
            <div class="right_long">
              <input
                class="long"
                type="text"
                placeholder="公司名称"
                v-model="company"
                @keyup.enter="summit"
              />
            </div>
            <div class="right_long">
              <input
                class="long"
                type="text"
                placeholder="您的姓名"
                v-model="name"
                @keyup.enter="summit"
              />
            </div>

            <div class="contact1">
              <input
                class="contact_small"
                type="tel"
                placeholder="联系电话"
                v-model="tel"
                @keyup.enter="summit"
              />
              <input
                class="contact_small"
                type="mail"
                placeholder="邮箱"
                v-model="mail"
                @keyup.enter="summit"
              />
            </div>
            <div class="right_long">
              <input
                class="long"
                type="text"
                placeholder="合作需求"
                v-model="details"
                @keyup.enter="summit"
              />
            </div>
            <div class="btn" @click="summit">提交免费咨询</div>
          </div>
        </div>
        <submit
          ref="submitMsgBox"
          :alert="alert"
          :formData="formData"
          @sonalert="sonalert"
          @sonsubmit="sonsubmit"
        ></submit>
        <div class="footer_box">
          <img class="kefu" src="../../assets/images/kefu.png" alt="" />
          <ul class="footer_ul1">
            <li class="title">JORUDAN</li>
            <li class="text">电话：021-5836-5030</li>
            <li class="text">传真：021-5836-5031</li>
            <li class="text">客服：400-8118-580</li>
            <li class="text">邮件：info@jorudan.com.cn</li>
          </ul>
          <ul class="footer_ul2">
            <!-- <li class="title">解决方案</li>
            <li class="title">集团业务（日本）</li> -->
            <li class="title">公司介绍</li>
            <li class="text" @click="jumpUrl('about')">关于我们</li>
            <li class="text" @click="jumpUrl('/news')">行业新闻</li>
            <li class="text" @click="jumpUrl('/group')">集团业务（日本）</li>
            <!-- <li class="text" @click="jumpUrl('fixed', 1)">会议预约系统</li>
            <li class="text" @click="jumpUrl('fixed', 2)">门禁监控系统</li>
            <li class="text" @click="jumpUrl('fixed', 3)">影像系统</li>
            <li class="text" @click="jumpUrl('fixed', 4)">电话交换机系统</li>
            <li class="text" @click="jumpUrl('fixed', 5)">网络系统</li>
            <li class="text" @click="jumpUrl('fixed', 6)">视频会议系统</li> -->
          </ul>
          <!-- <ul class="footer_ul3">
            <li class="title">集团业务（日本）</li>
            <li class="text" @click="goGroup('traffic', 2)">路线交通</li>
            <li class="text" @click="goGroup('food', 2)">人气美食</li>
            <li class="text" @click="goGroup('shop', 2)">休闲购物</li>
            <li class="text" @click="goGroup('travel', 2)">热门旅游</li>
            <li class="text" @click="goGroup('more', 2)">其他</li>
          </ul>
          <ul class="footer_ul4">
            <li class="title">公司介绍</li>
            <li class="text" @click="jumpUrl('about')">关于我们</li>
            <li class="text" @click="jumpUrl('/news')">行业新闻</li>
            <li class="text">联系我们</li>
          </ul> -->
          <!--ul class="footer_ul5">
            <li class="title">若尔丹（上海）</li>
            <li class="ma">
              <img src="../../assets/images/foot_wei.jpg" alt="" />
            </li>
          </ul-->
          <ul class="footer_ul5">
            <li class="title">乘换案内</li>
            <li class="ma">
              <img src="../../assets/images/norikae_f.jpg" alt="" />
            </li>
          </ul>
          <ul class="footer_ul6">
            <li class="title">霓虹微游</li>
            <li class="ma">
              <img src="../../assets/images/foot_wei-nihong.jpg" alt="" />
            </li>
          </ul>
        </div>
        <div class="down_box">
          <div class="down_left">
            <p class="left_text">
              <span><a href="https://www.jorudan.co.jp/">总社网站</a></span>
              ｜ <span @click="jumpUrl('/clause')">有效条款</span> ｜
              <span @click="jumpUrl('/statement')">隐私声明</span> ｜
              <span @click="jumpUrl('/advertise')">若尔丹招聘</span>
            </p>
          </div>
          <div class="down_right">
            <p class="right_text">
              Copyright © 2025 若尔丹（上海）软件开发有限公司All Rights Reserved
              <br />
              <a href="http://beian.miit.gov.cn/" target="_blank">信息产业部备案号：沪ICP备11046720号-4</a>&nbsp;&nbsp;
              <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010102005300" target="_blank">沪公网安备31010102005300号</a>
            </p>
            <div class="back" @click="toTop">
              <img src="../../assets/images/dingbu.png" alt="" />
              <div class="line_text">回顶部</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 移动端 -->
    <div class="home_app">
      <!-- app头部 -->
      <div class="header">
        <div class="top">
          <!-- logo -->
          <div class="pic">
            <img src="../../assets/images/app_logo.png" alt="" />
          </div>
          <!-- 菜单按钮 -->
          <div class="menu_pic" @click="openMenu">
            <img src="../../assets/images/app_caidan.png" alt="" />
          </div>
        </div>
        <!-- 遮罩层 -->
        <div class="shadow" @click="openMenu" v-show="isOpen == true"></div>
      </div>
      <!-- app菜单页 -->
      <transition
        :duration="1000"
        enter-active-class="animate__animated animate__fadeInRight"
        leave-active-class="animate__animated animate__fadeOutRight"
      >
        <div class="menu" v-show="isOpen == true">
          <ul class="list">
            <li class="menu_list" :class="{ active: $route.path == '/home' }">
              <span class="menu_sp" @click="jumpUrl('/home')">首页</span>
            </li>
            <li class="menu_list" :class="{ active: $route.path == '/case' }">
              <span class="menu_sp" @click="jumpUrl('/case')">典型案例</span>
            </li>
            <li class="menu_list" :class="{ active: $route.path == '/skill' }">
              <span class="menu_sp" @click="jumpUrl('/skill')">技术支持</span>
            </li>
            <li class="menu_list" :class="{ active: $route.path == '/fixed' }">
              <span class="menu_sp" @click="jumpUrl('/fixed')">解决方案</span>
            </li>
            <li class="menu_list" :class="{ active: $route.path == '/news' }">
              <span class="menu_sp" @click="jumpUrl('/news')">行业新闻</span>
            </li>
            <li class="menu_list" :class="{ active: $route.path == '/group' }">
              <span class="menu_sp" @click="jumpUrl('/group')">集团业务</span>
            </li>
            <li class="menu_list" :class="{ active: $route.path == '/about' }">
              <span class="menu_sp" @click="jumpUrl('/about')">关于我们</span>
            </li>
            <li style="margin-top: 50px; height: 1rem" class="menu_list" :class="{ active: $route.path == ''}">
              <span class="menu_sp changeLang" @click="changeLang($route.path)" style="font-size: 1.5rem">日本語版へ</span>
            </li>
            <!-- <li class="menu_line" @click="openMenu">
              <span class="lt">&lt;</span>
            </li> -->
          </ul>
        </div>
      </transition>

      <router-view></router-view>

      <!-- 联系我们 -->
      <div class="contact">
        <p class="us">联系我们</p>
        <p class="em">
          新的需求，从这里开始。欢迎填写表格或发送合作邮件至:
          <span>info@jorudan.com.cn</span>
        </p>
        <div class="inp">
          <div class="one">
            <input type="text" placeholder="您的姓名*" v-model="mname" />
            <input type="text" placeholder="您的电话*" v-model="mtel" />
          </div>
          <div class="one">
            <input type="text" placeholder="您的邮箱*" v-model="memail" />
            <input type="text" placeholder="公司名称*" v-model="company" />
          </div>
          <div class="one">
            <input style="margin-left: 0px;" type="text" placeholder="您的合作需求*" v-model="mdetails" />
          </div>
          <button @click="submitmobile">提交</button>
        </div>
      </div>
      <submitmobile
        :alert="alert"
        :mformData="mformData"
        @sonalert="sonalert"
        @sonsubmitm="sonsubmitm"
      ></submitmobile>
      <!-- app尾部 -->
      <div class="footer">
        <div class="footer_box1">
          <ul class="footer_ul1">
            <li class="title">JORUDAN</li>
            <li class="text">电话：021-5836-5030</li>
            <li class="text">传真：021-5836-5031</li>
            <li class="text">客服：400-8118-580</li>
            <li class="text">邮件：info@jorudan.com.cn</li>
          </ul>
          <div class="maList">
            <!--ul class="footer_ul2">
              <li class="title">若尔丹（上海）</li>
              <li class="ma">
                <img src="../../assets/images/foot_wei-nihong.jpg" alt="" />
              </li>
            </ul-->
            <ul class="footer_ul2">
              <li class="title">乘换案内</li>
              <li class="ma">
                <img src="../../assets/images/norikae_f.jpg" alt="" />
              </li>
            </ul>
            <ul class="footer_ul3">
              <li class="title">日本微游</li>
              <li class="ma">
                <img src="../../assets/images/foot_wei.jpg" alt="" />
              </li>
            </ul>
          </div>
        </div>
        <div class="footer_box2">
          <!-- <ul class="footer_ul4">
            <li class="title">解决方案</li>
            <li class="text" @click="jumpUrlFix(1)">会议预约系统</li>
            <li class="text" @click="jumpUrlFix(2)">门禁监控系统</li>
            <li class="text" @click="jumpUrlFix(3)">影像系统</li>
            <li class="text" @click="jumpUrlFix(4)">电话交换机系统</li>
            <li class="text" @click="jumpUrlFix(5)">网络系统</li>
            <li class="text" @click="jumpUrlFix(6)">视频会议系统</li>
          </ul>
          <ul class="footer_ul5">
            <li class="title">集团业务（日本）</li>
            <li class="text" @click="goGroup('traffic', 'app')">路线交通</li>
            <li class="text" @click="goGroup('food', 'app')">人气美食</li>
            <li class="text" @click="goGroup('shop', 'app')">休闲购物</li>
            <li class="text" @click="goGroup('travel', 'app')">热门旅游</li>
            <li class="text" @click="goGroup('more', 'app')">其他</li>
          </ul> -->

          <ul class="footer_ul6">
            <li class="title">公司介绍</li>
            <li class="text" @click="jumpUrlFn('/about')">关于我们</li>
            <li class="text" @click="jumpUrlFn('/news')">行业新闻</li>
            <li class="text" @click="jumpUrlFn('/group')">集团业务（日本）</li>
            <!-- <li class="text">联系我们</li> -->
          </ul>
          <ul class="footer_ul7">
            <li class="title">Biccamera</li>
            <li class="ma">
              <img src="../../assets/images/foot_wei-nihong.jpg" alt="" />
            </li>
          </ul>
        </div>
        <div class="footer_box3">
          <p>
            Copyright © 2024 若尔丹（上海）软件开发有限公司All Rights Reserved
            <br />
            <a class="a" href="http://beian.miit.gov.cn/" target="_blank">信息产业部备案号：沪ICP备11046720号-4</a>  
            <a class="a" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010102005300" target="_blank">沪公网安备31010102005300号</a>
          </p>
        </div>
        <!-- <div class="footer_box4"></div> -->
        <div class="back" @click="toTop">
          <img src="../../assets/images/dingbu.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import submit from "@/components/homePc/submit.vue";
import submitmobile from "@/components/homeMobile/submitmobile.vue";
export default {
  components: {
    submit,
    submitmobile,
  },
  data() {
    return {
      isOpen: false,
      isshowAd: "",
      company: "",
      name: "",
      tel: "",
      mail: "",
      details: "",
      formData: {},
      mname: "",
      memail: "",
      mtel: "",
      maddress: "",
      mrequire: "",
      alert: false,
      mformData: {},
      mdetails: ''
    };
  },
  mounted() {
    // 在项目加载完成之后初始化wow
    this.$nextTick(() => {
      this.$wow.init();
    });
    // rem适配;
    let width = document.body.offsetWidth;
    const htmlObj = document.getElementsByTagName("html")[0];
    htmlObj.style.fontSize = width / 63.4 + "px";
    // 对resize事件进行浏览器兼容处理
    if (document.createEvent) {
      var event = document.createEvent("HTMLEvents");
      event.initEvent("resize", true, true);
      window.dispatchEvent(event);
    } else if (document.createEventObject) {
      window.fireEvent("onresize");
    }
    // 监听页面resize事件，重新设置rem的根字体大小
    window.onresize = function () {
      let width = document.body.offsetWidth;
      htmlObj.style.fontSize = width / 63.4 + "px";
    };

    //导航栏高度变化
    const navbar = document.getElementById('navbar');

    window.addEventListener('scroll', function() {
      navbar.classList.add('header_transition');
      if (window.pageYOffset < 200) {
        // 页面在顶部时，显示正常大小的导航栏
        navbar.classList.remove('header_small');
      } else {
        // 页面不在顶部时，缩小导航栏
        navbar.classList.add('header_small');
      }
    });
    //修改标题为中文
    document.title='若尔丹(上海)软件开发有限公司';
    //alert('cn pages!');
  },
  watch: {
    $route() {
      location.reload();
    },
  },
  methods: {
    // 移动端
    submitmobile() {
      if (
        this.mname &&
        this.mtel &&
        this.memail &&
        this.company &&
        this.mdetails
      ) {
        this.mformData = {
          name: this.mname,
          tel: this.mtel,
          mail: this.memail,
          company: this.company,
          mdetails: this.mdetails,
        };
        this.alert = true;
		
		this.mname = "";
        this.mtel = "";
        this.memail = "";
        this.company = "";
        this.mdetails = "";
		
      } else {
        alert("请完善信息");
      }
    },
    sonsubmitm() {
      this.alert = false;
      this.mname = "";
      this.maddress = "";
      this.mtel = "";
      this.mrequire = "";
      this.memail = "";
    },
    // 移动端打开菜单
    openMenu() {
      this.isOpen = !this.isOpen;
    },
    // 移动端路由跳转
    jumpUrlFn(val) {
      this.$router.push(val).catch((err) => {
        return err;
      });
      this.toTop();
    },
    // 移动端解决方案跳转
    jumpUrlFix(sum) {
      this.$router.push("/fixed").catch((err) => {
        return err;
      });
      if (sum == 1) {
        document.documentElement.scrollTop = 660;
      } else if (sum == 2) {
        document.documentElement.scrollTop = 1060;
      } else if (sum == 3) {
        document.documentElement.scrollTop = 1400;
      } else if (sum == 4) {
        document.documentElement.scrollTop = 2040;
      } else if (sum == 5) {
        document.documentElement.scrollTop = 1750;
      } else if (sum == 6) {
        document.documentElement.scrollTop = 2300;
      }
    },
    // PC端
    sonalert() {
      this.alert = false;
    },
    sonsubmit() {
      this.alert = false;
      this.company = "";
      this.name = "";
      this.tel = "";
      this.mail = "";
      this.details = "";
    },
    summit() {
      if (this.company && this.name && this.tel && this.mail && this.details) {
        this.formData = {
          company: this.company,
          name: this.name,
          tel: this.tel,
          mail: this.mail,
          details: this.details,
        };
        this.alert = true;
		
		this.company = "";
		this.name = "";
		this.tel = "";
		this.mail = "";
		this.details = "";
		
      } else {
        this.$refs.submitMsgBox.isError = true;
      }
    },
	
    // pc端跳转路由
    jumpUrl(url, num) {
      this.$router.push(url).catch((err) => {
        return err;
      });

      this.isOpen = !this.isOpen;
      if (num == 1) {
        document.documentElement.scrollTop = 0;
      } else if (num == 2) {
        document.documentElement.scrollTop = 0;
      } else if (num == 3) {
        document.documentElement.scrollTop = 0;
      } else if (num == 4) {
        document.documentElement.scrollTop = 0;
      } else if (num == 5) {
        document.documentElement.scrollTop = 0;
      } else if (num == 6) {
        document.documentElement.scrollTop = 0;
      } else {
        document.documentElement.scrollTop = 0;
      }
    },

    changeLang(url, num) {
      //console.log(this.$route)
      let path = this.$route.path
      if (path.indexOf('/ja') === 0) {
        path = path.replace('/ja', '')
      } else {
        path = `/ja${path}`
      }

      this.$router.push(path).catch((err) => {
        return err;
      });
    },
    // 返回顶部
    //toTop() {
      //document.documentElement.scrollTop = 0;
    //   scrollToTop(500);
    //},
    toTop() {
      var scrollStep = -window.scrollY / (300 / 15);
      var scrollInterval = setInterval(function() {
        if (window.scrollY !== 0) {
          window.scrollBy(0, scrollStep);
        } else {
          clearInterval(scrollInterval);
        }
      }, 15);
    },

    //新闻页面显示下划线
    isNewsPath() {
      const regex = /^(.*)\/news/;
      //console.log(regex.test(this.$route.path));
      return regex.test(this.$route.path);
    },

    // 集团业务
    goGroup(type, i) {
      this.$router.push("/group").catch((err) => {
        return err;
      });
      this.$store.state.groupName = type;
      if (i == "app") {
        document.documentElement.scrollTop = 0;
      } else {
        document.documentElement.scrollTop = 0;
      }
    },
    showAd(val) {
      this.isshowAd = val;
      console.log(this.isshowAd);
    },
    outShow() {
      this.isshowAd = "";
    },
  },
};
</script>

<style lang="less" scoped>
.all {
  position: relative;
  @media screen and(max-width : 992px) {
    .home {
      display: none;
    }
    // 移动端
    .home_app {
      font-family: Source Han Sans CN;
      height: 100vh;
      width: 100vw;
      padding-top: 5.8rem;

      // app头部
      .header {
        width: 100%;
        height: 5.78rem;
        position: fixed;
        top: 0;
        left: 0;
        background: #fff;
        z-index: 2;

        .shadow {
          width: 100%;
          height: calc(100vh - 5.79rem);
          position: fixed;
          right: 0;
          top: 5.8rem;
          background-color: #000;
          opacity: 0.5;
          z-index: 999;
        }

        .top {
          box-shadow: 0rem 0rem 1rem 0rem rgb(11 50 144 / 7%);
          width: 100%;
          height: 5.78rem;
          display: flex;
          justify-content: space-between;
          padding: 1.5rem 1.5rem;

          .pic {
            width: 13.67rem;
            height: 3.33rem;

            img {
              width: 13.67rem;
              height: 3.33rem;
            }
          }

          .menu_pic {
            width: 3.42rem;
            height: 3.17rem;

            img {
              width: 3.42rem;
              height: 3.17rem;
            }
          }
        }
      }

      // app菜单
      .menu {
        z-index: 9999;
        width: 24rem;
        height: 100%;
        position: fixed;
        top: 5.78rem;
        right: 0px;
        background: #ffffff;
        box-shadow: -1rem 0rem 3rem 0rem rgba(38, 72, 197, 0.18);

        .list {
          width: 100%;
          padding-left: 2.5rem;
          // position: relative;
          padding-top: 5rem;

          .active {
            background: rgba(11, 50, 144, 0.18);
            border-radius: 4rem 0rem 0rem 4rem;

            .menu_sp {
              color: #0b3290 !important;
            }
          }

          .menu_list {
            width: 100%;
            height: 7.1rem;
            text-align: center;

            .menu_sp {
              font-size: 2.3rem;
              font-family: PingFang SC;
              font-weight: 400;
              color: #333333;
              line-height: 7.1rem;
            }
          }

          .changeLang {
            margin-left: 3rem;
            height: 3rem;
            line-height: 0rem !important;
            position: relative;
          }

          .changeLang::before {
            position: absolute;
            left: -3rem;
            bottom: 0.025rem;
            content: "";
            display: block;
            width: 2rem;
            height: 2rem;
            background-image: url("../../assets/images/jp_icon.png");
            background-size: 100% 100%;
          }

          // .menu_line {
          //   width: 5rem;
          //   height: 5rem;
          //   border-radius: 100%;
          //   background: #fff;
          //   position: absolute;
          //   left: -2rem;
          //   top: 50%;
          //   transform: translate(0, -50%);
          //   box-shadow: -2.6rem 0px 2.5rem -1.5rem rgba(38, 72, 197, 0.18);

          //   .lt {
          //     position: absolute;
          //     top: 50%;
          //     left:10%;
          //     transform: translate(0, -50%);
          //     // width: 1.16rem;
          //     // height: 2.16rem;
          //     display: block;
          //     font-size: 3rem;
          //     font-weight: 500;
          //     color: rgba(11, 50, 144, 1);
          //   }
          // }
        }
      }

      // 联系我们
      .contact {
        margin-top: 9rem;
        .us {
          font-size: 2.7rem;
          color: #666;
          font-weight: 600;
          text-align: center;
          margin-bottom: 2rem;
        }

        .em {
          font-size: 1.5rem;
          color: #444;
          opacity: 0.8;
          font-weight: 300;
          text-align: center;
          margin-bottom: 3rem;

          span {
            color: #7f8bb9;
          }
        }

        .inp {
          width: 95%;
          margin: 0 auto;
          box-sizing: border-box;
          padding: 3rem 2.5rem;
          box-shadow: 0rem 0rem 1rem 0rem rgb(11 50 144 / 7%);
          border-radius: 1rem;
          background-color: #fff;

          .one {
            display: flex;

            input {
              width: 100%;
              height: 4.7rem;
              background: #ffffff;
              border: 1px solid #dee5f9;
              border-radius: 1rem;
              margin-bottom: 1.8rem;
              box-sizing: border-box;
              padding: 1rem;
              font-size: 1.7rem;
            }

            input:last-child {
              margin-left: 1.75rem;
            }
          }

          .two {
            textarea {
              width: 100%;
              height: 12rem;
              background: #ffffff;
              border: 1px solid #dee5f9;
              border-radius: 1rem;
              margin-bottom: 1.8rem;
              box-sizing: border-box;
              padding: 1rem;
              font-size: 1.7rem;
              font-family: PingFang SC;
            }
          }
        }

        button {
          display: block;
          width: 23.52rem;
          height: 4.55rem;
          background: #0b3290;
          box-shadow: 0rem 1rem 3rem 0rem rgb(38 73 197 / 15%);
          border-radius: 2rem;
          color: #fff;
          font-size: 2rem;
          text-align: center;
          margin: 0 auto;
          border: none;
          outline: none;
        }
      }

      // app尾部
      .footer {
        z-index: -1;
        width: 100%;
        height: 70rem;
        background: #0b3290;
        margin-top: 1.67rem;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        padding: 3rem 1.5rem;
        position: relative;

        .title {
          font-size: 2rem;
          font-family: PingFang SC;
          font-weight: 600;
          color: #ffffff;
          // opacity: 0.8;
          margin-bottom: 2rem;
        }

        .text {
          font-size: 1.5rem;
          font-family: PingFang SC;
          font-weight: 300;
          color: #ffffff;
          opacity: 0.8;
          margin: 5px 0;
        }

        .ma {
          img {
            width: 8.5rem;
            height: 8.5rem;
          }
        }

        .footer_box1 {
          display: flex;
          justify-content: space-between;

          .footer_ul1 {
            width: 50%;
          }

          .maList {
            display: flex;
            flex: 1;
            justify-content: space-around;
          }
        }

        .footer_box2 {
          display: flex;
          justify-content: space-between;
        }

        .footer_box3 {
          display: flex;
          justify-content: space-between;

          p {
            font-size: 1.17rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #acacac;
          }

          .a{
            color: #acacac;
          }
        }

        .back {
          position: absolute;
          bottom: 7rem;
          right: 5rem;

          img {
            width: 3.5rem;
          }
        }
      }
    }
  }

  @media screen and(min-width:992px) {
    // pc端
    .home {
      font-family: Source Han Sans CN;
      .active_bg {
        background: #f0f3f9;
      }

      .header {
        top: 0;
        position: fixed;
        z-index: 1000;
        width: 100%;
        height: 2.8rem;
        background: #fff;
        //transition: height 0.3s ease;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

        .top {
          height: 100%;

          .pic::after {
            content: "若尔丹(上海)软件开发有限公司";
            font-family: "Source Han Sans CN", sans-serif;
            font-size: 0.55rem;
            padding-left: 0.6rem;
            font-weight: 600;
          }

          .pic {
            float: left;
            margin-left: 1.666667rem;
            display: flex;
            align-items: center;
            height: 100%;


            img {
              width: auto;
              height: 1.066667rem;
            }
          }

          .top_title {
            float: right;
            margin-right: 1rem;
            display: flex;
            justify-content: space-around;
            align-items: center;
            height: 100%;
            text-align: center;

            .active {
              color: #0b3290 !important;
            }

            .title_li {
              margin: 0 13px;
              //width: 3.8rem;
              display: flex;
              align-items: center;
              justify-content: center;

              a {
                position: relative;
                font-size: 1.1vw;
                font-family: 'Source Han Sans CN',sans-serif;
                font-weight: 600;
                color: #333333;

                .line {
                  width: 100%;
                  height: 3px;
                  background: #0634a3;
                  position: absolute;
                  bottom: -0.3rem;
                  left: 50%;
                  transform: translate(-50%, 0);
                }
              }

              a::before {
                content: "";
                display: block;
                position: absolute;
                left: 0;
                bottom: -0.3rem;
                height: 3px;
                width: 100%;
                background: #0634a3;
                -webkit-transition: -webkit-transform 0.8s
                  cubic-bezier(0.4, 0, 0.2, 1);
                transition: -webkit-transform 0.8s cubic-bezier(0.4, 0, 0.2, 1);
                transition: transform 0.8s cubic-bezier(0.4, 0, 0.2, 1);
                transition: transform 0.8s cubic-bezier(0.4, 0, 0.2, 1),
                  -webkit-transform 0.8s cubic-bezier(0.4, 0, 0.2, 1);
                -webkit-transform: scaleX(0);
                -ms-transform: scaleX(0);
                transform: scaleX(0);
                -webkit-transform-origin: right center;
                -ms-transform-origin: right center;
                transform-origin: right center;
              }

              a:hover::before {
                -webkit-transform: scaleX(1);
                -ms-transform: scaleX(1);
                transform: scaleX(1);
                -webkit-transform-origin: left center;
                -ms-transform-origin: left center;
                transform-origin: left center;
              }

              a:hover {
                color: #0b3290;
              }
              .switch {
                position: relative;
                display: inline-block;
                width: 60px;
                height: 34px;
              }

              .switch input {
                opacity: 0;
                width: 0;
                height: 0;
              }

              .switch {
                scale: 75%;
                // left: 4rem;
                position: relative;
                display: inline-block;
                width: 60px;
                height: 34px;
                bottom: 0.05rem;
              }

              .switch_small {
                scale: initial;
                left: 80px;
                position: relative;
                display: inline-block;
                width: 60px;
                height: 34px;
                bottom: 1px;
              }

              .switch input {
                opacity: 0;
                width: 0;
                height: 0;
              }

              .slider {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background-color: #bbbbbb;
                border-radius: 34px;
                transition: .4s;
                box-shadow: inset 2px 2px 8px rgba(0, 0, 0, 0.5);
                cursor: pointer;
              }


              .lan_btn {
                position: absolute;
                content: "";
                height: 30px;
                width: 30px;
                left: 4px;
                bottom: 2px;
                border-radius: 50%;
                transition: .4s;
                transform: translateX(-2px);
                box-shadow: -2px 2px 8px black;
              }

              .slider-label {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                font-size: 12px;
                color: #bbbbbb;
              }

              .slider-label.on {
                transform: translate(-50%, -50%) translateX(22px);
              }

              input:checked + .slider {
                background-color: #bbbbbb;
              }

              input:checked + .slider:before {
                transform: translateX(26px);
              }

              .slider.round {
                border-radius: 34px;
              }

              .slider.round:before {
                border-radius: 50%;
              }

            }

            .about {
              width: 4rem;
              display: flex;
              align-items: center;
              justify-content: center;

              a {
                background: #01349e;
                border-radius: 0.6rem;
                color: #fff;
                padding: 0.266667rem;
                font-size: 0.533333rem;
                font-family: Source Han Sans CN;
                font-weight: 600;
                transition: background-color 1s;
              }

              a:hover {
                color: #01349e;
                background: #fff;
                border: 1px solid #01349e;
              }
            }
          }
        }
      }



      .header_transition {
        transition: height 0.3s ease;
      }
      .header_small {
        height: 1.5rem;
        background-color: rgba(255,255,255,0.8);
      }

      .details {
        //margin-top: 2.8rem;
      }

      .footer {
        width: 100%;
        background: #002f9c;

        padding-bottom: 1.666667rem;

        .contact {
          width: 100%;
          height: 14.566667rem;
          display: flex;
          justify-content: center;
          align-items: center;
          background: url("../../assets/images/eight_bg.png") no-repeat;
          background-size: cover;

          .contact_left {
            display: flex;
            flex-direction: column;
            margin-right: 1rem;
            justify-content: space-around;
            padding: 2rem 0.5rem;
            width: 14.733333rem;
            height: 11.866667rem;
            position: relative;
            .showAdd {
              width: 17.2rem;
              height: 8.666667rem;
              position: absolute;
              left: -1.733333rem;
              top: -2.9rem;
              box-shadow: -0.033333rem 0px 1.566667rem 0.4rem
                rgba(64, 64, 64, 0.18);

              img {
                width: 100%;
                height: 100%;
              }

              .trangle1 {
                width: 0px;
                height: 0px;
                border-top: 0.333333rem solid #fff;
                border-left: 0.333333rem solid transparent;
                border-right: 0.333333rem solid transparent;
                position: absolute;
                bottom: -0.333333rem;
                right: 5.666667rem;
              }

              .trangle2 {
                width: 0px;
                height: 0px;
                border-top: 0.333333rem solid #fff;
                border-left: 0.333333rem solid transparent;
                border-right: 0.333333rem solid transparent;
                position: absolute;
                bottom: -0.333333rem;
                right: 9.633333rem;
              }

              .trangle3 {
                width: 0px;
                height: 0px;
                border-top: 0.333333rem solid #fff;
                border-left: 0.333333rem solid transparent;
                border-right: 0.333333rem solid transparent;
                position: absolute;
                bottom: -0.333333rem;
                right: 13.333333rem;
              }
            }

            .us {
              font-size: 0.766667rem;
              font-family: Source Han Sans CN;
              font-weight: 500;
              color: #fff;
            }

            .iphone {
              height: 2.133333rem;
              font-size: 0.8rem;
              font-family: Source Han Sans CN;
              font-weight: 500;
              color: #fff;
              line-height: 0.8rem;
              border-bottom: 1px solid #e1e2e2;

              .phone {
                font-size: 0.6rem;
                font-family: Source Han Sans CN;
                font-weight: 500;
                color: #fff;

                margin-bottom: -0.666667rem;
                display: block;
              }
            }

            .address {
              color: #e1e2e2;
              font-size: 0.6rem;
              height: 1.433333rem;
              border-bottom: 1px solid #e1e2e2;

              .ad {
                font-size: 0.666667rem;
                font-family: Source Han Sans CN;
                font-weight: bold;
                color: #fff;
                cursor: pointer;
              }
            }

            .jpic {
              display: flex;
              align-items: center;

              .jp {
                font-size: 0.6rem;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #fff;
                line-height: 0.833333rem;
                display: block;
                margin-left: 0.166667rem;
              }

              img {
                width: 0.733333rem;
                height: 0.8rem;
                vertical-align: middle;
              }
            }
          }

          .contact_right {
            width: 22.666667rem;
            height: 11.866667rem;
            background-color: #fff;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            padding: 0.5rem 0 0.5rem 0.966667rem;

            .contact_right_title {
              font-size: 0.766667rem;
              font-family: Source Han Sans CN;
              font-weight: 500;
              color: #222222;
            }

            .right_long {
              width: 100%;

              .long {
                width: 20.8rem;
                height: 1.666667rem;
                background: #ffffff;
                border: 1px solid #dee5f9;
                border-radius: 0.133333rem;
                outline: none;
                padding-left: 0.5rem;
              }
            }

            .contact1 {
              display: flex;
              justify-content: space-between;
              align-items: center;

              width: 21.066667rem;

              .contact_small {
                width: 10.066667rem;
                height: 1.666667rem;
                background: #ffffff;
                border: 1px solid #dee5f9;
                border-radius: 0.133333rem;
                margin-right: 0.266667rem;
                outline: none;
                padding-left: 0.5rem;
              }
            }

            .btn:hover {
              color: #0b3290;
              background: #fff;
              border: 1px solid #0b3290;
              transition: all 1s;
            }

            .btn {
              box-sizing: border-box;
              text-align: center;
              font-size: 0.666667rem;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #ffffff;
              width: 20.733333rem;
              height: 1.7rem;
              background: #0b3290;
              box-shadow: 0px 0.333333rem 1rem 0px rgba(38, 73, 197, 0.15);
              border-radius: 0.133333rem;
              line-height: 1.7rem;
              cursor: pointer;
              border: 1px solid transparent;
            }
          }
        }

        .footer_box {
          width: 100%;

          position: relative;
          display: flex;
          justify-content: space-around;
          padding: 0.666667rem 11.7rem 0 9.2rem;

          .kefu {
            width: 1.133333rem;
            height: 1.033333rem;
            position: absolute;
            left: 8.4rem;
            top: 0.666667rem;
          }

          .footer_ul1 {
            width: 8.533333rem;
            border-right: 1px solid rgba(255, 255, 255, 0.12);
            height: 7.466667rem;
          }

          .ma {
            img {
              width: 2.666667rem;
              height: 2.8rem;
            }
          }

          .title {
            font-size: 0.6rem;
            margin-bottom: 0.833333rem;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #ffffff;
            opacity: 0.8;
          }

          .text:hover {
            opacity: 1;
          }

          .text {
            font-size: 0.466667rem;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #ffffff;
            opacity: 0.6;
            margin: 0.333333rem 0;
            cursor: pointer;
          }
        }

        .down_box {
          width: 43.333333rem;
          margin: 0 auto;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          padding: 0.666667rem 1.533333rem 0 0.666667rem;
          height: 2.666667rem;
          border-top: 1px dashed rgba(255, 255, 255, 0.12);
          margin-top: 1rem;

          .down_left {
            width: 95%;
            .left_text {
              a {
                font-size: 0.466667rem;
                font-family: Source Han Sans CN;
                font-weight: 500;
                color: #fff;
                cursor: pointer;
              }

              font-size: 0.466667rem;
              font-family: Source Han Sans CN;
              font-weight: 500;
              color: #fff;
              cursor: pointer;
            }
          }

          .down_right {
            width: 95%;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .right_text {
              font-size: 0.4rem;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #acacac;

              a{
                color:#acacac;
              }
            }

            .back {
              margin-left: 0.666667rem;
              display: flex;
              justify-content: space-around;
              flex-direction: column;
              align-items: center;
              cursor: pointer;

              img {
                width: 1rem;
                height: 1.066667rem;
                margin-bottom: 0.166667rem;
              }

              .line_text {
                font-size: 0.4rem;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #ffffff;
                opacity: 0.6;
              }
            }
          }
        }
      }
    }
    .home_app {
      display: none;
    }
  }
}
@media screen and(min-width:1500px) {
  .title_li {
    a {
      font-size: 16.5px !important;
      //color: red !important;
    }
  }
}
</style>